module.exports = __webpack_public_path__ + "c6ff10f2cf8403db4d0395b3d02a0eb7.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/macbook.png
// module id = 714
// module chunks = 0